import { lazy, Suspense } from 'react';
import { motion } from 'framer-motion';
import { useReducedMotion } from '../../../hooks/useReducedMotion';
import './hero.scss';

const ViolinScene = lazy(() => import('./ViolinScene'));

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay, duration: 0.9, ease: [0.25, 1, 0.5, 1] },
  }),
};

export default function Hero() {
  const reduced = useReducedMotion();

  return (
    <section className="hero" id="hero">
      <div className="hero__canvas">
        {!reduced && (
          <Suspense fallback={null}>
            <ViolinScene />
          </Suspense>
        )}
      </div>

      <div className="hero__frame">
        {/* Bottom-left: name + tagline */}
        <div className="hero__corner hero__corner--bl">
          <motion.h1
            className="hero__name"
            initial="hidden"
            animate="show"
            custom={0.4}
            variants={fadeUp}
          >
            <span className="hero__name-line">Arisa</span>
            <span className="hero__name-line hero__name-line--alt">Nemoto</span>
          </motion.h1>
          <motion.p
            className="hero__quote"
            initial="hidden"
            animate="show"
            custom={0.7}
            variants={fadeUp}
          >
            Code that listens.<br />Music that thinks.
          </motion.p>
        </div>

        {/* Bottom-right: meta + scroll */}
        <motion.div
          className="hero__corner hero__corner--br"
          initial="hidden"
          animate="show"
          custom={0.7}
          variants={fadeUp}
        >
          <dl className="hero__meta">
            <div>
              <dt>Based in</dt>
              <dd>Tokyo, Japan</dd>
            </div>
            <div>
              <dt>Focus</dt>
              <dd>LLM products &amp; live performance</dd>
            </div>
          </dl>
          <a className="hero__scroll" href="#work">
            <span>Selected work</span>
            <span className="hero__scroll-arrow" aria-hidden>↓</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
